// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1G2SL","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2kDDr"};